import axios, { AxiosRequestConfig } from 'axios';
import { getLOCALUSERLayerId, getTENANTLayerId } from '../../utils';

const BASEURL = '/session/api/ext/objstore/v1beta/objects/';

export const orionObject = async (options: Record<string, string>) => {
  let requestUrl = `${BASEURL}${options.type}`;

  if (options.filter && options.filter !== '') {
    requestUrl = requestUrl.concat(`?filter=${options.filter}`);
  }

  const requestConfig: AxiosRequestConfig = {
    url: requestUrl,
    method: 'GET',
    headers: {
      Accept: 'application/json; charset=UTF-8',
      'layer-type': options.layerType,
      'layer-id': options.layerType === 'LOCALUSER' ? getLOCALUSERLayerId() : getTENANTLayerId(),
      'Content-Type': 'application/json',
    },
  };

  const response = await axios(requestConfig);
  return response.data;
};

export const patchOrionObject = async (options: Record<string, string>, requestObj: Record<string, string>) => {
  const requestConfig: AxiosRequestConfig = {
    url: BASEURL + options.type + '/' + options.id,
    method: 'PATCH',
    data: requestObj.patchBody as unknown as Blob,
    headers: {
      Accept: 'application/json; charset=UTF-8',
      'layer-type': options.layerType,
      'layer-id': options.layerType === 'LOCALUSER' ? getLOCALUSERLayerId() : getTENANTLayerId(),
      'Content-Type': 'application/json-patch+json',
    },
  };

  const response = await axios(requestConfig);
  return response.data;
};

export const putOrionObject = async (options: Record<string, string>, requestObj: Record<string, string>) => {
  const requestConfig: AxiosRequestConfig = {
    url: BASEURL + options.type + '/' + options.id,
    method: 'PUT',
    data: requestObj.body,
    headers: {
      Accept: 'application/json; charset=UTF-8',
      'layer-type': options.layerType,
      'layer-id': options.layerType === 'LOCALUSER' ? getLOCALUSERLayerId() : getTENANTLayerId(),
      'Content-Type': 'application/json',
    },
  };

  const response = await axios(requestConfig);
  return response.data;
};
